import Loader from "../utils/Loader";
import { useState, useRef, useEffect } from 'react';
import useNotifications from "../hooks/useNotifications";
import NotificationPreviewModal from "./NotificationPreviewModal";
import NotificationDrawer from "./NotificationDrawer";
import moment from "moment";
import { userManualDownloadUrl, disclaimer } from '../utils/constants';
import { useNavigate, Link } from "react-router-dom";


const VisitorHeader = () => {
    const navigate = useNavigate();

    const [isLoading, setLoader] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);
    const { notifications, unreadCount, markAllRead, previewItem, openPreview, closePreview, showDrawer, openDrawer, closeDrawer } = useNotifications();
    const notificationRef = useRef(null);
    const notificationMobileRef = useRef(null);
    const marqueeRef = useRef(null);

    // Exhibition From Date
    const dateString = sessionStorage.getItem('exhibitionDateFrom');
    const dateStringMoment = moment.utc(dateString, "DD/MM/YYYY").format('DD MMMM YYYY')
    const dateObject = new Date(dateStringMoment);
    const fromDay = dateObject.getDate();
    const fromMonth = dateObject.toLocaleString('default', { month: 'long' });
    const fromYear = dateObject.getFullYear();
    const fromDate = `${fromDay} ${fromMonth} ${fromYear}`;
    console.log('dateString', dateString)
    console.log('dateStringMoment', dateStringMoment)
    console.log('dateObject', dateObject)

    // Exhibition to Date
    const dateString1 = sessionStorage.getItem('exhibitionDateTo');
    const dateString1Moment = moment.utc(dateString1, "DD/MM/YYYY").format('DD MMMM YYYY')
    const dateObject1 = new Date(dateString1Moment);
    const toDay = dateObject1.getDate();
    const toMonth = dateObject1.toLocaleString('default', { month: 'long' });
    const toYear = dateObject1.getFullYear();
    const toDate = `${toDay} ${toMonth} ${toYear}`;

    // Exhibition Logo File Path
    const logoPath = sessionStorage.getItem('sessionLogoPath')
    const ExhibitionEmail = JSON.parse(sessionStorage.getItem('sessionExhibitionEmail'))
    const ExhibitionMobileNo = JSON.parse(sessionStorage.getItem('sessionExhibitionMobileNo'))

    // Exhibition Address
    const address = sessionStorage.getItem('exhibitionAddress')

    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

    const location = window.location.hash || window.location.pathname;
    const isVisitorRegistration = location.toLowerCase().includes("visitorregistration");

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };

    const onLogoutClick = () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/login");
    };

    const corporateLink = sessionStorage.getItem("sessionExhMailWebsite") || "https://corporate.india-itme.com";

    useEffect(() => {
        function handleClickOutside(event) {
            const inDesktop = notificationRef.current && notificationRef.current.contains(event.target);
            const inMobile = notificationMobileRef.current && notificationMobileRef.current.contains(event.target);
            if (!inDesktop && !inMobile) {
                setShowNotifications(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    return (
        <>
            {isLoading ? (
                <Loader></Loader>
            ) : (
                null
            )}

            {isMobileMenuOpen && (
                <div
                    className="mobile-menu-overlay exhibitor-mobile-overlay"
                    onClick={closeMobileMenu}
                ></div>
            )}


            <div
                className={`mobile-sidebar-menu exhibitor-mobile-menu ${isMobileMenuOpen ? "mobile-menu-open" : ""
                    }`}
            >
                <div className="mobile-menu-header exhibitor-menu-header">
                    <button
                        onClick={closeMobileMenu}
                        className="exhibitor-menu-close-btn text-white"
                    >
                        ×
                    </button>
                    <div className="user-info exhibitor-user-info">
                        <h4 className="text-uppercase fw-semibold text-white fw-bold">
                            {sessionStorage.getItem("sessionExhibitionName")}
                        </h4>
                    </div>
                </div>
                <div className="mobile-menu-content exhibitor-menu-content">
                    {/* MOBILE NOTIFICATIONS */}
                    {!isVisitorRegistration && (
                    <div className="menu-section mobile-notification-section">
                        <h6 className="exhibitor-section-title">
                            <i className="fa fa-bell" aria-hidden="true"></i> Notifications
                            {unreadCount > 0 && <span className="notification-badge" style={{ position: 'static', display: 'inline-flex', marginLeft: 4 }}>{unreadCount}</span>}
                        </h6>
                        {notifications.length === 0 ? (
                            <p className="mobile-notif-item">No notifications</p>
                        ) : notifications.slice(0, 3).map(n => (
                            <div key={n.id} className="mobile-notif-item">
                                <span className={`mobile-notif-dot${n.unread ? "" : " read"}`}></span>
                                <span>{n.title}</span>
                            </div>
                        ))}
                    </div>
                    )}

                    <div className="menu-section exhibitor-details-section">
                        <h6 class="exhibitor-section-title text-center border-bottom-0" style={{ color: 'white' }}>Owned and Organised by</h6>
                        <a style={{ width: '150px' }} href="index.html">
                            <img src="../images/itme-right-logo.png" className="header-brand-img desktop-logo" alt="logo" />
                        </a>
                    </div>

                    <div className="menu-section exhibitor-details-section">
                        <h6 className="exhibitor-section-title">Exhibition Details</h6>
                        <p className="exhibitor-detail-text mb-2">
                            {sessionStorage.getItem("exhibitionDateFrom")} -{" "}
                            {sessionStorage.getItem("exhibitionDateTo")} <br />
                            {address}
                        </p>
                    </div>

                    <div className="menu-section exhibitor-details-section">
                        <h6 className="exhibitor-section-title">For Assistance</h6>
                        <p className="exhibitor-detail-text mb-2">
                            {ExhibitionMobileNo} <br />
                            {ExhibitionEmail} <br />
                        </p>
                    </div>

                    <div className="menu-section exhibitor-links-section">
                        <h6 className="exhibitor-section-title gap-1">Quick Links</h6>
                        <a
                            href={corporateLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="exhibitor-menu-link mb-2 mobi"
                            onClick={closeMobileMenu}
                        >
                            For new corporate site please <span className="text-primary ms-1"> Click here</span>
                        </a>

                    </div>
                </div>
            </div>

            <div className="app-header header sticky app-heder-with-logo">
                <div className="container-fluid main-container pe-2">
                    <div className="d-flex mt-1 mt-lg-0">
                        {/* <a className="logo-horizontal " href="index.html">
                            <img
                                src={logoPath} className="header-brand-img desktop-logo" alt="logo" />
                        </a> */}
                        <div className="d-flex">
                            <a className="logo-horizontal " href="index.html">
                                <img
                                    src={logoPath} className="header-brand-img desktop-logo" alt="logo" />
                            </a>
                            <div class="side-header">
                                {/* <a class="header-brand1" >
                                     <img src={logoPath} class="header-brand-img header-brand-img-1 light-logo1" alt="top-left logo" />
                                 </a> */}
                                <div class="side-header">
                                    <a class="header-brand1" >
                                        <img src={logoPath} class="header-brand-img header-brand-img-1 light-logo1 m-0" alt="top-left logo" />
                                    </a>
                                </div>

                                {/* <p className=" header-assistance text-white">
                                     For Assistance
                                     <br>
                                     </br>
                                     {ExhibitionMobileNo.length > 0 ? ExhibitionMobileNo.map((data, i) => (<>
                                         {data}{i != ExhibitionMobileNo.length - 1 ? ',' : null}
                                     </>
                                     )) : null}
                                     <br>
                                     </br>
                                     {ExhibitionEmail.length > 0 ? ExhibitionEmail.map((data, i) => (
                                         <a href={data} > {data} {i != ExhibitionEmail.length - 1 ? '/' : null} </a>
                                     )) : null}
                                 </p> */}


                                {/* <div class="right-logo">
                <p className='right-logo-text' style={{ top: '20px' }}>Owned and Organised by</p>
                <img src="../images/itme-right-logo.png" className="header-brand-img desktop-logo" alt="logo" />
              </div> */}

                            </div>
                            <p style={{ color: 'white' }} className=" header-logo-name" >{fromDate} - {toDate} <br></br>
                                {address}
                            </p>
                            <p className=" header-assistance" style={{ width: '25rem', marginTop: '-15px', color: 'white' }}>
                                For Assistance
                                <br>
                                </br>
                                {ExhibitionMobileNo.length > 0 ? ExhibitionMobileNo.map((data, i) => (<>
                                    {data}{i != ExhibitionMobileNo.length - 1 ? ',' : null}
                                </>
                                )) : null}
                                <br>
                                    {/* ` ${(data)}`(i != ExhibitionMobileNo.length - 1 ? ',' : null) */}
                                </br>
                                {ExhibitionEmail.length > 0 ? ExhibitionEmail.map((data, i) => (
                                    <a style={{ color: 'white' }} href={data} > {data} {i != ExhibitionEmail.length - 1 ? '/' : null} </a>
                                )) : null}
                            </p>


                            <div class="right-logo d-flex align-items-center gap-3">
                                {/* Desktop Notification Bell */}
                                {!isVisitorRegistration && (
                                <div className="notification-bell-wrapper d-none d-lg-inline-flex" ref={notificationRef}>
                                    <i
                                        className="fa fa-bell fa-lg text-white"
                                        onClick={() => setShowNotifications(!showNotifications)}
                                        style={{ cursor: 'pointer' }}
                                    ></i>
                                    {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
                                    {showNotifications && (
                                        <div className="notification-dropdown shadow">
                                            <div className="notification-dropdown-header">
                                                <span>Notifications</span>
                                                {unreadCount > 0 && <button className="mark-all-read-btn" onClick={markAllRead}>Mark all as read</button>}
                                            </div>
                                            {notifications.length === 0 ? (
                                                <div className="notification-empty">No notifications</div>
                                            ) : notifications.slice(0, 3).map(n => (
                                                <div key={n.id} className={`notification-item${n.unread ? " unread" : ""}`}>
                                                    <span className={`notification-item-icon ${n.type}`}>
                                                        {n.initial}
                                                    </span>
                                                    <div className="notification-item-content">
                                                        <div className="notification-item-title" dangerouslySetInnerHTML={{ __html: n.title }}></div>
                                                        {n.time && <div className="notification-item-time">{n.time}</div>}
                                                    </div>
                                                    <span className="notification-eye-btn" title="Preview" onClick={() => openPreview(n.id)}><i className="fa fa-eye"></i></span>
                                                </div>
                                            ))}
                                            <div className="notification-dropdown-footer" style={{ cursor: 'pointer' }} onClick={openDrawer}>View all notifications</div>
                                        </div>
                                    )}
                                </div>
                                )}
                                <div>
                                    <p className='right-logo-text' style={{ top: '20px', color: 'white' }}>Owned and Organised by</p>
                                    <img src="../images/itme-right-logo.png" className="header-brand-img desktop-logo" alt="logo" />
                                </div>
                            </div>

                        </div>
                        {/* <p className="header-logo-name text-white" >{fromDate} - {toDate} <br></br>
                            {address}
                        </p> */}
                        {/* <p className="header-logo-name text-white">
                            {fromDate} - {toDate}
                            <br />
                            {address && (
                                <>
                                    {address.slice(0, 45)}
                                    <br />
                                    {address.slice(45)}
                                </>
                            )}
                        </p> */}


                        {/* <div class="right-logo">
                            <p className='right-logo-text text-nowrap text-white' style={{ top: '8px' }}>Owned and Organised by</p>
                            <p className=" header-assistance text-white text-nowrap">
                                For Assistance &nbsp;
                                {ExhibitionMobileNo.length > 0 ? ExhibitionMobileNo.map((data, i) => (<>
                                    {data}{i != ExhibitionMobileNo.length - 1 ? ',' : null}
                                </>
                                )) : null}
                                <br>
                                </br>
                                {ExhibitionEmail.length > 0 ? ExhibitionEmail.map((data, i) => (
                                    <a href={data} > {data} {i != ExhibitionEmail.length - 1 ? '/' : null} </a>
                                )) : null}
                            </p>
                            <img src="../images/itme-right-logo.png" className="header-brand-img desktop-logo" alt="logo" />
                        </div> */}

                    </div>
                    <div
                        className="marquee-text"
                        style={{
                            marginTop: window.innerWidth <= 991 ? '0px' : '-17px'
                        }}
                    >

                        <marquee
                            behavior="scroll"
                            direction="left"
                            scrollamount="5"
                            ref={marqueeRef}
                            onMouseOver={() => marqueeRef.current?.stop()}
                            onMouseOut={() => marqueeRef.current?.start()}
                        >
                            <b>Disclaimer and Ownership:</b> {disclaimer}
                        </marquee>
                    </div>
                </div>

                <div className="mobile-toggle exhibitor-mobile-toggle d-lg-none pe-1 d-flex align-items-center gap-2">
                    {/* Mobile Notification Bell */}
                    {!isVisitorRegistration && (
                    <div className="notification-bell-wrapper" ref={notificationMobileRef} style={{ padding: '3px 7px' }}>
                        <i
                            className="fa fa-bell fa-lg text-white"
                            onClick={() => setShowNotifications(!showNotifications)}
                            style={{ cursor: 'pointer' }}
                        ></i>
                        {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
                        {showNotifications && (
                            <div className="notification-dropdown shadow">
                                <div className="notification-dropdown-header">
                                    <span>Notifications</span>
                                    {unreadCount > 0 && <button className="mark-all-read-btn" onClick={markAllRead}>Mark all as read</button>}
                                </div>
                                {notifications.length === 0 ? (
                                    <div className="notification-empty">No notifications</div>
                                ) : notifications.map(n => (
                                    <div key={n.id} className={`notification-item${n.unread ? " unread" : ""}`}>
                                        <span className={`notification-item-icon ${n.type}`}>
                                            {n.initial}
                                        </span>
                                        <div className="notification-item-content">
                                            <div className="notification-item-title">{n.title}</div>
                                            <div className="notification-item-time">{n.time}</div>
                                        </div>
                                        <span className="notification-eye-btn" title="Preview" onClick={() => openPreview(n.id)}><i className="fa fa-eye"></i></span>
                                    </div>
                                ))}
                                <div className="notification-dropdown-footer" style={{ cursor: 'pointer' }} onClick={openDrawer}>View all notifications</div>
                            </div>
                        )}
                    </div>
                    )}
                    <button
                        onClick={toggleMobileMenu}
                        className="exhibitor-menu-toggle-btn"
                    >
                        <span className="exhibitor-menu-toggle-bar"></span>
                        <span className="exhibitor-menu-toggle-bar"></span>
                        <span className="exhibitor-menu-toggle-bar"></span>
                    </button>
                </div>
            </div>


        <NotificationDrawer show={showDrawer} notifications={notifications} unreadCount={unreadCount} markAllRead={markAllRead} openPreview={openPreview} onClose={closeDrawer} />
        <NotificationPreviewModal notification={previewItem} onClose={closePreview} />
        </>
    )
}

export default VisitorHeader;